import { Button, Space, message } from 'antd'
import { useToken } from 'app/hooks'
import React from 'react'
import API from 'utils/api'
import { useTradeModalStore } from '../hooks/trade/modalStore'

const SendMessage = ({ target, targetid }) => {
	const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore()

	return (
		<>
			<Button
				type="default"
				size="small"
				onClick={() => {
					mutateModalStore({
						...modalStore,
						sendmodal: true,
						sendtarget: target,
						sendtargetid: targetid,
					})
				}}>
				{target == 'all' ? '전체메시지 전송' : '메시지전송'}
			</Button>
		</>
	)
}

export default SendMessage
